// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1ViHm","title":"InfoRow_title__7C3RG"};